import React from 'react'
import styled from 'styled-components'

import { IMAGE_SIZES, getCloserAuthorizedSize } from '@hozana/styling/image'

import { BorderedDiv, TBorderedDivProps } from 'elements/layout/BorderedDiv'
import { BgImage, TBgImageProps } from 'elements/media/BgImage'

import { COMMUNITY_AVATAR_SIZES } from 'modules/community/constants'

const defaultImg = '/img/hozana_img_community_default.png'

export type TStyledBorderedDivProps = {
  greyScale?: boolean
} & TBorderedDivProps

const StyledBorderedDiv = styled(BorderedDiv)<TStyledBorderedDivProps>`
  display: inline-block;
  ${(props) => props.greyScale && 'filter: grayscale(100%);'}
  ${(props) => props.greyScale && 'opacity: 0.5;'}
  &:hover {
    filter: none;
    opacity: 1;
  }
`

export type TCommunityAvatarProps = {
  size?: number
  selected?: boolean
} & Pick<TStyledBorderedDivProps, 'greyScale'> &
  Pick<TBgImageProps, 'src'>

export const CommunityAvatar: TFC<TCommunityAvatarProps> = ({
  src,
  size = COMMUNITY_AVATAR_SIZES.SMALL,
  selected,
  greyScale,
}) => {
  const squareSize = getCloserAuthorizedSize(size, COMMUNITY_AVATAR_SIZES)
  return (
    <StyledBorderedDiv
      h={`${COMMUNITY_AVATAR_SIZES[squareSize]}px`}
      w={`${COMMUNITY_AVATAR_SIZES[squareSize]}px`}
      borderRadius="20%"
      bg="white"
      noOverflow
      borderWidth={selected ? '3px' : '0'}
      borderColor={selected ? 'darkBlue' : 'transparent'}
      greyScale={greyScale && !selected}
    >
      <BgImage
        src={src || defaultImg}
        bgSize="cover"
        imageSize={IMAGE_SIZES.community.square}
        bg="white"
        bgPosition="center center"
        w="100%"
        h="100%"
      />
    </StyledBorderedDiv>
  )
}
